import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import WhiteList from './whiteList';
import { getNSGlobalSettingsPageInfo } from '../../../redux/actions/settings';
import { getNSRIWhiteListInitiate } from '../../../redux/actions/ns/runInstance';

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    settings: state.settings,
    whiteListData: state.nsRunInstanceConfig.whiteList
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        navigateTo: (path) => push(path),
        getNSGlobalSettingsPageInfo,
        getNSRIWhiteListInitiate
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WhiteList);
